import type { FC } from 'react';
import { memo } from 'react';
import TableForm from './form';

import { NodePanelProps } from '../../types';
import type { TableExtractionNodeType } from './types';

const Panel: FC<NodePanelProps<TableExtractionNodeType>> = ({
  formRef,
  initialValue,
  node_id,
  readonly,
}) => {
  return (
    <div className="p-4">
      <TableForm
        node_id={node_id}
        initialValue={initialValue}
        ref={formRef}
        readonly={readonly}
      />
    </div>
  );
};

export default memo(Panel);
